import { Box, Modal, Paper, Typography, Button, type ButtonProps } from '@mui/material';
import { useStyles } from '../styles/ConfirmModal.styles';

import type { ReactNode } from 'react';

type ButtonOption = Exclude<ButtonProps, 'ref' | 'children'> & {
    text: string;
};

export type PaperModalProps = {
    open: boolean;
    title: string;
    buttons?: ButtonOption[];
    children?: ReactNode;
};

/**
 * Base modal component with styling.
 */
export const PaperModal = ({ open, title, children, buttons }: PaperModalProps) => {
    const styles = useStyles();

    return (
        <Modal open={open}>
            <Paper className={styles.container}>
                <Box className={styles.header}>
                    <Typography color='white' fontWeight='bold'>
                        {title}
                    </Typography>
                </Box>

                <Box className={styles.content}>{open && children}</Box>

                <Box className={styles.buttonContainer}>
                    {buttons?.map(({ text, ...props }) => (
                        <Button key={`modal-${text}`} size='small' variant='contained' {...props}>
                            {text}
                        </Button>
                    ))}
                </Box>
            </Paper>
        </Modal>
    );
};
